import script from "./CreateInitial.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateInitial.vue?vue&type=script&setup=true&lang=js"

import "./CreateInitial.vue?vue&type=style&index=0&id=7c3915bb&lang=css"

const __exports__ = script;

export default __exports__